import i from './login.container';

export default i;
